import ListDataTitleDesc from './list-data-title-desc';

export default ListDataTitleDesc;
